<script setup lang="ts">
const { sidebarElements } = useSidebar();
const { loggedIn } = useAuth();

const showSidebar = computed(() => loggedIn.value);
</script>

<template>
  <div class="flex min-h-screen bg-gray-50 dark:bg-gray-900">
    <ClientOnly>
      <AppSidebar
        v-if="showSidebar"
        :elements="sidebarElements"
      />
    </ClientOnly>

    <main
      class="flex-1 transition-all duration-300 w-full"
      :class="[
        showSidebar ? 'lg:ml-64' : ''
      ]"
    >
      <UContainer
        :ui="{ width: 'max-w-none' }"
        class="h-full px-2 sm:px-4 py-2 sm:py-4 pt-16 lg:pt-4"
      >
        <div class="mb-2 sm:mb-4">
          <AppBreadcrumb />
        </div>
        <slot />
      </UContainer>
    </main>
  </div>
</template>
